import { IWrite } from './interfaces/IWrite';
import { IRead } from './interfaces/IRead';
import { store } from '../App';

export abstract class BaseRepository<T> implements IWrite<T>, IRead<T> {
  static apiUrl = process.env.REACT_APP_API_URL;

  static authHeader() {
    const state = store.getState();

    if (state && state.authentication && state.authentication.accessToken) {
      return {
        Authorization: 'Bearer ' + state.authentication.accessToken
      };
    } else {
      return;
    }
  }

  create(item: T): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
  update(id: string, item: T): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
  delete(id: string): Promise<boolean> {
    throw new Error('Method not implemented.');
  }
  find(item: T): Promise<T[]> {
    throw new Error('Method not implemented.');
  }
  findOne(id: string): Promise<T> {
    throw new Error('Method not implemented.');
  }
}
